export * from './src/identity-v1-contributor-contributors.universal.js';
